import { Alert, Code, FieldLabel, Pill } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function ParseNumberInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel hint="Stripped before parsing">Characters to ignore</FieldLabel>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {['$', '€', '£', '¥', ',', '_', '%', 'spaces'].map(s => (
          <Pill key={s} tone="opt">{s}</Pill>
        ))}
      </div>
      <FieldLabel>Decimal separator</FieldLabel>
      <Segmented
        value={c.decimal || '.'}
        onChange={(v) => u({ decimal: v })}
        options={[
          { value: '.', label: '1,234.56' },
          { value: ',', label: '1.234,56' },
        ]}
      />
      <Alert kind="info" style={{ marginTop: 12 }}>
        Trailing <Code>%</Code> divides by 100. Empty / unparseable cells are
        kept as their original string per the cast policy.
      </Alert>
    </div>
  );
}
